import type { OrgParamProps } from './types';

/**
 * Filter function for the All Organizations table.
 */
export const AllOrganizationsTableFilterFn = (row: OrgParamProps, filter: string) => {
  return (
    row.name.toLowerCase().includes(filter.toLowerCase()) ||
    row.website.toLowerCase().includes(filter.toLowerCase()) ||
    row.industry.toLowerCase().includes(filter.toLowerCase()) ||
    row.estimatedSize.toString().toLowerCase().includes(filter.toLowerCase()) ||
    row.id.toString().toLowerCase().includes(filter.toLowerCase()) ||
    row.adminUserId.toLowerCase().includes(filter.toLowerCase())
  );
};
